import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klik op de knop hieronder om uw betalingsgegevens te bekijken en te bevestigen.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'We werken samen met Stripe voor de betalingsverwerking. Stripe is het veiligste betalingsplatform dat door de grootste bedrijven wereldwijd wordt gebruikt.',
      form: {
        terms_acceptance: {
          label:
            'Door verder te gaan, gaat u akkoord met onze <FoodAmigosTerms>Serviceovereenkomst</FoodAmigosTerms> en de <StripeTerms>Stripe Connected Account-overeenkomst.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe heeft bepaalde klantgegevens als ontbrekend of ongeldig gemarkeerd. Corrigeer de volgende fouten door op de knop „Stripe-profiel openen" te klikken:',
        errors: 'Fouten',
        awaiting_verification: 'Uw Stripe-account wordt geverifieerd',
        awaiting_verification_description:
          'We wachten tot Stripe uw bedrijf heeft geverifieerd. U kunt uw profiel in de tussentijd bekijken.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'We werken samen met Adyen voor betalingsverwerking. Adyen is een van de veiligste betalingsplatformen, gebruikt door de grootste bedrijven wereldwijd.',
    },
  },
  labels: {
    verified: 'Uw {{paymentGateway}}-account is geverifieerd',
    verified_description:
      'Verificatie voor {{paymentGateway}} is voltooid. U kunt uw profiel nog altijd beheren indien nodig.',
  },
  buttons: {
    proceed: 'Betalingsgegevens bevestigen',
    copy_link: 'Link kopiëren',
  },
  toasts: {
    something_went_wrong: 'Er is iets misgegaan, neem contact op met technische ondersteuning',
  },
};
